import { render, staticRenderFns } from "./ConfirmPhoneNumber.vue?vue&type=template&id=c536579e&scoped=true&"
import script from "./ConfirmPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c536579e",
  null
  
)

export default component.exports